(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('StatusUpdateFormController', StatusUpdateFormController);

  /* ngInject */
  function StatusUpdateFormController($state, $timeout, $window, Flash, Upload, config, smcProfileService, sessionService) {
    const vm = this;

    vm.profiles = [];
    vm.statusUpdate = {
      file_type: 'image'
    };
    vm.saveStatusUpdate = saveStatusUpdate;

    $window.bsCustomFileInput.init();

    activate();

    function activate() {
      getProfiles();
    }

    function getProfiles() {
      smcProfileService(sessionService.getAuthToken()).query(response => vm.profiles = response);
    }

    function saveStatusUpdate() {
      // Server accepts hash with profile IDs as keys, so we need to map the array to the correct format before
      // sending to the server
      vm.statusUpdate.identity = {};
      vm.statusUpdate.profile_ids.map(profile_id => {
        vm.statusUpdate.identity[profile_id] = '';
      });

      Upload.upload(
        {
          url: `${config.socialMediaComplianceApiEndpoint}/api/status_updates`,
          method: 'POST',
          data: vm.statusUpdate,
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        }
      ).then(_ => {
        $timeout(() => {
          $state.go('application.social_media_compliance.status_updates');
          Flash.create('success', 'Status update successfully created.');
        });
      }, _ => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      });
    }
  }
})();
